import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

const TIMEOUT = 5000;
const INTERVAL = 5000;

class Collage extends Controller {
  connect() {
    if (this.getSvgPaths().length === this.getAvailableImages().length) {
      return;
    }

    setTimeout(() => {
      setInterval(() => {
        this.randomizeImages();
      }, INTERVAL);
    }, TIMEOUT);
  }

  randomizeImages() {
    this.getSvgPaths().forEach(() => {
      const randomImageSource = this.getRandomImage();
      const randomSvgPath = Math.floor(Math.random() * this.getSvgPaths().length);
      const randomSvgPathSource = this.getSvgHrefs()[randomSvgPath];

      this.changeImage(randomImageSource, randomSvgPathSource);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  changeImage(image, destination) {
    $(destination).fadeOut(() => {
      destination.setAttribute('xlink:href', image);

      $(destination).fadeIn();
    });
  }

  getRandomImage() {
    const imageIndex = Math.floor(Math.random() * this.getAvailableImages().length);

    this.getAvailableImages().splice(imageIndex, 1);

    return this.getAvailableImages()[imageIndex];
  }

  getAvailableImages() {
    return this.imageTargets.map((image) => image.src);
  }

  getSvgHrefs() {
    return toArray(this.svgTarget.querySelectorAll('image'));
  }

  getSvgPaths() {
    return toArray(this.svgTarget.querySelectorAll('path[fill]'));
  }
}

Collage.targets = [
  'image',
  'svg',
];

export default Collage;
